// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31_HN","col":"styles_col__I9QV8"};